import './PageTab.css';

export default function PageTab({is_selected = false, tabName = '', icon_src = "", label_txt = "Example", onSelected = () => null}){
    return <div
        className={is_selected ? 'PageTab PageTabSelected': 'PageTab'}
        onClick={() => onSelected(tabName)}
    >
        {label_txt}
    </div>;
}
